/**
 * @hidden

 */
export var created = 'create';
/**
 * @hidden

 */
export var destroyed = 'destroy';
/**
 * @hidden

 */
export var load = 'load';
/**
 * Specifies Rich Text Editor internal events
 */
/**
 * @hidden

 */
export var initialLoad = 'initial-load';
/**
 * @hidden

 */
export var contentChanged = 'content-changed';
/**
 * @hidden

 */
export var initialEnd = 'initial-end';
/**
 * @hidden

 */
export var iframeMouseDown = 'iframe-click';
/**
 * @hidden

 */
export var destroy = 'destroy';
/**
 * @hidden

 */
export var toolbarClick = 'toolbarClick';
/**
 * @hidden

 */
export var toolbarRefresh = 'toolbar-refresh';
/**
 * @hidden

 */
export var refreshBegin = 'refresh-begin';
/**
 * @hidden

 */
export var toolbarUpdated = 'toolbar-updated';
/**
 * @hidden

 */
export var bindOnEnd = 'bind-on-end';
/**
 * @hidden

 */
export var renderColorPicker = 'render-color-picker';
/**
 * @hidden

 */
export var htmlToolbarClick = 'html-toolbar-click';
/**
 * @hidden

 */
export var markdownToolbarClick = 'markdown-toolbar-click';
/**
 * @hidden

 */
export var destroyColorPicker = 'destroy-color-picker';
/**
 * @hidden

 */
export var modelChanged = 'model-changed';
/**
 * @hidden

 */
export var keyUp = 'keyUp';
/**
 * @hidden

 */
export var keyDown = 'keyDown';
/**
 * @hidden

 */
export var mouseUp = 'mouseUp';
/**
 * @hidden

 */
export var toolbarCreated = 'toolbarCreated';
/**
 * @hidden

 */
export var toolbarRenderComplete = 'toolbarRenderComplete';
/**
 * @hidden

 */
export var enableFullScreen = 'enableFullScreen';
/**
 * @hidden

 */
export var disableFullScreen = 'disableFullScreen';
/**
 * @hidden

 */
export var dropDownSelect = 'dropDownSelect';
/**
 * @hidden

 */
export var beforeDropDownItemRender = 'beforeDropDownItemRender';
/**
 * @hidden

 */
export var execCommandCallBack = 'execCommandCallBack';
/**
 * @hidden

 */
export var imageToolbarAction = 'image-toolbar-action';
/**
 * @hidden

 */
export var linkToolbarAction = 'link-toolbar-action';
/**
 * @hidden

 */
export var windowResize = 'resize';
/**
 * @hidden

 */
export var resizeStart = 'resizeStart';
/**
 * @hidden

 */
export var onResize = 'resizing';
/**
 * @hidden

 */
export var resizeStop = 'resizeStop';
/**
 * @hidden

 */
export var undo = 'undo';
/**
 * @hidden

 */
export var redo = 'redo';
/**
 * @hidden

 */
export var insertLink = 'insertLink';
/**
 * @hidden

 */
export var unLink = 'unLink';
/**
 * @hidden

 */
export var editLink = 'editLink';
/**
 * @hidden

 */
export var openLink = 'openLink';
/**
 * @hidden

 */
export var actionBegin = 'actionBegin';
/**
 * @hidden

 */
export var actionComplete = 'actionComplete';
/**
 * @hidden

 */
export var updatedToolbarStatus = 'updatedToolbarStatus';
/**
 * @hidden

 */
export var actionSuccess = 'actionSuccess';
/**
 * @hidden

 */
export var updateToolbarItem = 'updateToolbarItem';
/**
 * @hidden

 */
export var insertImage = 'insertImage';
/**
 * @hidden

 */
export var insertCompleted = 'insertCompleted';
/**
 * @hidden

 */
export var imageLeft = 'justifyLeft';
/**
 * @hidden

 */
export var imageRight = 'justifyRight';
/**
 * @hidden

 */
export var imageCenter = 'justifyCenter';
/**
 * @hidden

 */
export var imageBreak = 'break';
/**
 * @hidden

 */
export var imageInline = 'inline';
/**
 * @hidden

 */
export var imageLink = 'insertImgLink';
/**
 * @hidden

 */
export var imageAlt = 'imgAltText';
/**
 * @hidden

 */
export var imageDelete = 'delete';
/**
 * @hidden

 */
export var imageCaption = 'caption';
/**
 * @hidden

 */
export var imageSize = 'imageSize';
/**
 * @hidden

 */
export var sourceCode = 'sourceCode';
/**
 * @hidden

 */
export var updateSource = 'updateSource';
/**
 * @hidden

 */
export var toolbarOpen = 'toolbarOpen';
/**
 * @hidden

 */
export var beforeDropDownOpen = 'beforeDropDownOpen';
/**
 * @hidden

 */
export var selectionSave = 'selection-save';
/**
 * @hidden

 */
export var selectionRestore = 'selection-restore';
/**
 * @hidden

 */
export var expandPopupClick = 'expandPopupClick';
/**
 * @hidden

 */
export var count = 'count';
/**
 * @hidden

 */
export var contentFocus = 'contentFocus';
/**
 * @hidden

 */
export var contentBlur = 'contentBlur';
/**
 * @hidden

 */
export var mouseDown = 'mouseDown';
/**
 * @hidden

 */
export var sourceCodeMouseDown = 'sourceCodeMouseDown';
/**
 * @hidden

 */
export var editAreaClick = 'editAreaClick';
/**
 * @hidden

 */
export var scroll = 'scroll';
/**
 * @hidden

 */
export var contentscroll = 'contentscroll';
/**
 * @hidden

 */
export var colorPickerChanged = 'colorPickerChanged';
/**
 * @hidden

 */
export var tableColorPickerChanged = 'tableColorPickerChanged';
/**
 * @hidden

 */
export var focusChange = 'focusChange';
/**
 * @hidden

 */
export var selectAll = 'selectAll';
/**
 * @hidden

 */
export var selectRange = 'selectRange';
/**
 * @hidden

 */
export var getSelectedHtml = 'getSelectedHtml';
/**
 * @hidden

 */
export var renderInlineToolbar = 'renderInlineToolbar';
/**
 * @hidden

 */
export var paste = 'paste-content';
/**
 * @hidden

 */
export var imgModule = 'imageModule';
/**
 * @hidden

 */
export var rtlMode = 'rtl-mode';
/**
 * @hidden

 */
export var createTable = 'createTable';
/**
 * @hidden

 */
export var docClick = 'docClick';
/**
 * @hidden

 */
export var tableToolbarAction = 'table-toolbar-action';
/**
 * @hidden

 */
export var checkUndo = 'checkUndoStack';
/**
 * @hidden

 */
export var readOnlyMode = 'readOnlyMode';
/**
 * @hidden

 */
export var pasteClean = 'pasteClean';
/**
 * @hidden

 */
export var enterHandler = 'enterHandler';
/**
 * @hidden

 */
export var beforeDialogOpen = 'beforeDialogOpen';
/**
 * @hidden

 */
export var clearDialogObj = 'clearDialogObj';
/**
 * @hidden

 */
export var dialogOpen = 'dialogOpen';
/**
 * @hidden

 */
export var beforeDialogClose = 'beforeDialogClose';
/**
 * @hidden

 */
export var dialogClose = 'dialogClose';
/**
 * @hidden

 */
export var beforeQuickToolbarOpen = 'beforeQuickToolbarOpen';
/**
 * @hidden

 */
export var quickToolbarOpen = 'quickToolbarOpen';
/**
 * @hidden

 */
export var quickToolbarClose = 'quickToolbarClose';
/**
 * @hidden

 */
export var popupHide = 'popupHide';
/**
 * @hidden

 */
export var imageSelected = 'imageSelected';
/**
 * @hidden

 */
export var imageUploading = 'imageUploading';
/**
 * @hidden

 */
export var imageUploadSuccess = 'imageUploadSuccess';
/**
 * @hidden

 */
export var imageUploadFailed = 'imageUploadFailed';
/**
 * @hidden

 */
export var imageRemoving = 'imageRemoving';
/**
 * @hidden

 */
export var afterImageDelete = 'afterImageDelete';
/**
 * @hidden

 */
export var drop = 'drop';
/**
 * @hidden

 */
export var xhtmlValidation = 'xhtmlValidation';
/**
 * @hidden

 */
export var beforeImageUpload = 'beforeImageUpload';
/**
 * @hidden

 */
export var resizeInitialized = 'resizeInitialized';
/**
 * @hidden

 */
export var renderFileManager = 'renderFileManager';
/**
 * @hidden

 */
export var beforeImageDrop = 'beforeImageDrop';
/**
 * @hidden

 */
export var dynamicModule = 'dynamicModule';
/**
 * @hidden

 */
export var beforePasteCleanup = 'beforePasteCleanup';
/**
 * @hidden

 */
export var afterPasteCleanup = 'afterPasteCleanup';
/**
 * @hidden

 */
export var updateTbItemsStatus = 'updateTbItemsStatus';
/**
 * @hidden

 */
export var showLinkDialog = 'showLinkDialog';
/**
 * @hidden

 */
export var closeLinkDialog = 'closeLinkDialog';
/**
 * @hidden

 */
export var showImageDialog = 'showImageDialog';
/**
 * @hidden

 */
export var closeImageDialog = 'closeImageDialog';
/**
 * @hidden

 */
export var showTableDialog = 'showTableDialog';
/**
 * @hidden

 */
export var closeTableDialog = 'closeTableDialog';
